module.exports = __webpack_public_path__ + "img/type-7-1.cdc08ba2.png";